import { PendingChatTarget, RecentChat } from './types'

const RECENT_KEY = 'chat-search:recent'
const PENDING_KEY = 'chat-search:pending'
const RECENT_LIMIT = 8

function canUseStorage() {
	return typeof window !== 'undefined'
}

export function readRecentChats(): RecentChat[] {
	if (!canUseStorage()) {
		return []
	}
	try {
		const raw = localStorage.getItem(RECENT_KEY)
		if (!raw) {
			return []
		}
		const parsed = JSON.parse(raw) as RecentChat[]
		if (!Array.isArray(parsed)) {
			return []
		}
		return parsed.filter((item) => item?.chatUid && item?.modelSlug && item?.title)
	} catch {
		return []
	}
}

export function pushRecentChat(item: RecentChat) {
	if (!canUseStorage() || !item.chatUid || !item.modelSlug || !item.title) {
		return
	}
	const next = [item, ...readRecentChats().filter((chat) => chat.chatUid !== item.chatUid)].slice(0, RECENT_LIMIT)
	localStorage.setItem(RECENT_KEY, JSON.stringify(next))
}

export function readPendingChatTarget(): PendingChatTarget | null {
	if (!canUseStorage()) {
		return null
	}
	try {
		const raw = sessionStorage.getItem(PENDING_KEY)
		if (!raw) {
			return null
		}
		const parsed = JSON.parse(raw) as PendingChatTarget
		if (!parsed?.chatUid || !parsed?.modelSlug) {
			return null
		}
		return parsed
	} catch {
		return null
	}
}

export function writePendingChatTarget(target: PendingChatTarget) {
	if (!canUseStorage()) {
		return
	}
	sessionStorage.setItem(PENDING_KEY, JSON.stringify(target))
}

export function clearPendingChatTarget() {
	if (!canUseStorage()) {
		return
	}
	sessionStorage.removeItem(PENDING_KEY)
}
